const labels = {
    // Address
    'Adres': 'Street address',
    'Kod pocztowy': 'Postal code',
    'Miasto': 'City',
    // ButtonWithPopup
    'Sprawdź czy wprowadzone dane są kompletne i poprawne.': 'Check if data you entered are complete and valid',
    // Candidate
    'Nazwa firmy': 'Company',
    'Adres url': 'Website',
    'Wielkość': '',
    'Mały podmiot': '',
    'Średni / duży podmiot': '',
    'Członek e-Izby': 'e-Chamber member/partner',
    'Tak': 'Yes',
    'Nie': 'No',
    // Footer
    'Zgłoś problem': 'Report problem',
    // Invoice
    'Dane do faktury': 'Invoice',
    'Nazwa': 'Company name',
    'NIP': 'Tax number',
    // LogoUpload
    'Logotyp': 'Logotype',
    'Przeciągnij logotyp zgłaszanego podmiotu': 'Drag logotype',
    '(format png lub jpg; maksymalny rozmiar 1MB)': '(png lub jpg; max size 1MB)',
    'Przeciągnij logotyp zgłaszanego podmiotu': 'Drag logotype',
    '(format wektorowy: svg lub eps; maksymalny rozmiar 1MB)': '(max size 1MB)',
    'Logotyp gotowy do przesłania': 'Logotype ready to be uploaded',
    // Submitter
    'Dane kontaktowe': 'Contact info',
    'Imię i nazwisko zgłaszającego': 'First and last name of the applicant',
    'Adres e-mail': 'Email',
    'Telefon': 'Phone',
    // SummaryPage
    'Dziękujemy za zgłoszenie do konkursu': 'Thank you for applying to the',
    'Zgłoszenie jest ważne po uiszczeniu opłaty za fakturę proforma. Organizator skontaktuje się z Państwem w najbliższym czasie.': 'The application will be considered by the Jury after paying the fee for the invoice. We will contact you within a few hours.',
    'Z poważaniem,': 'Sincerely,',
    'Organizator konkursu': 'the organizer of the',
    'Kod zgłoszenia': 'Application ID',
    // ECP / Agreements
    'zgoda na przesyłanie informacji o konkursie i gali e-Commerce Polska Awards': 'I want to receive an information about the Performance Marketing Diamonds CEE competition and the gala',
    'zgoda na informacje o innych aktywnościach Izby Gospodarki Elektronicznej': 'I want to receive more information about the activities of the e-Chamber of Digital Economy',
    'akceptuję': 'Accept',
    'regulamin': 'terms and conditions',
    // ECP / FormPage
    "Nazwa zgłaszanego podmiotu": 'Title of the application',
    'Usuń': 'Remove',
    'Zgłaszający': 'Applicant',
    'Dodaj zgłaszającego': 'Add applicant',
    'Dane lidera zgłoszenia': 'Application leader',
    'Dodaj kategorię': 'Add category',
    'Wyślij zgłoszenie': 'Submit application',
    // ECP / Submission
    'Kategoria': 'Category',
    'Tytuł zgłoszenia (będzie wykorzystane przy ewentualnej nominacji)': 'Title of the declaration / Name of the product ( it will be used for possible nomination)',
    'Opis zgłoszenia (400-1000 znaków)': 'Description of the application (400-1000 characters)',
    'Prezentacja': 'Presentation',
    'Przeciągnij prezentację zgłaszanego podmiotu': 'Drag presentation',
    '(format pdf; maksymalny rozmiar 5MB)': '(format pdf; max size 5MB)',
    'Prezentacja gotowa do przesłania': 'Presentation ready to be uploaded',
    'Oświadczenie Klienta': 'Client Statement',
    'Przeciągnij oświadczenie klienta': 'Drag client statement',
    '(format pdf; maksymalny rozmiar 5MB)': '(format pdf; max size 5MB)',
    'Oświadczenie klienta gotowe do przesłania': 'Client statement ready to be uploaded',
}

export default labels